import React from 'react';

export const IntegrationCheck: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_14712_34755)">
      <path
        d="M7.50016 13.5001L4.00016 10.0001L2.8335 11.1667L7.50016 15.8334L17.5002 5.83341L16.3335 4.66675L7.50016 13.5001Z"
        fill="#399E7C"
      />
    </g>
    <defs>
      <clipPath id="clip0_14712_34755">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
